<template>
    <!-- See How It Works -->
    <section class="see-works-six-section">
		<div class="container">
			<div class="section-heading section-heading-six">
				<div class="row">
					<div class="col-md-9 aos" data-aos="fade-up">
						<div class="reason-six">
							<img src="@/assets/img/icons/cleaner-clean-svgrepo-com.svg" alt="image" class="rounded-circle">
							<p>HOW WE ARE WORKING?</p>
						</div>
						<h2>See How It <span>Works</span></h2>
					</div>
				</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-lg-4 col-md-6 col-12">
					<div class="how-it-works-six">
						<div class="works-six-num">
							<h2>01</h2>
						</div>
						<div class="work-online-schedule">
							<div class="work-online-img">
								<img src="@/assets/img/works-six-1.png" alt="image" class="img-fluid">
							</div>
							<div class="work-online-bottom">
								<img src="@/assets/img/icons/gui-calendar-planner.svg" alt="image">
								<h4>Easy Online Scheduling</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-6 col-12">
					<div class="how-it-works-six">
						<div class="works-six-num works-six-num-two">
							<h2>02</h2>
						</div>
						<div class="work-online-schedule">
							<div class="work-online-img">
								<img src="@/assets/img/works-six-2.png" alt="image" class="img-fluid">
							</div>
							<div class="work-online-bottom work-online-bottom-two">
								<h4>Get A Certified Cleaner</h4>
								<img src="@/assets/img/icons/carpet.svg" alt="image">
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-6 col-12">
					<div class="how-it-works-six">
						<div class="works-six-num works-six-num-three">
							<h2>03</h2>
						</div>
						<div class="work-online-schedule">
							<div class="work-online-img">
								<img src="@/assets/img/works-six-3.png" alt="image" class="img-fluid">
							</div>
							<div class="work-online-bottom">
								<img src="@/assets/img/icons/like-svg.svg" alt="image">
								<h4>Enjoy Cleanliness!</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    <!-- /See How It Works -->

    <!-- Latest Blog -->
    <section class="blogs-service-section bg-white">
			<div class="container">
				<div class="section-heading section-heading-six">
					<div class="row align-items-end">
						<div class="col-md-9 aos" data-aos="fade-up">
							<div class="reason-six">
								<img src="@/assets/img/icons/cleaning-mop.svg" alt="image" class="rounded-circle">
								<p>AFFORDABLE & RELIABLE</p>
							</div>
							<h2>Latest <span>Blog</span></h2>
						</div>
						<div class="col-md-3 aos" data-aos="fade-up">
							<router-link to="/blogs/blog-details" class="afford-btn">Explore All</router-link>
						</div>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-lg-4 col-md-6 col-12 d-flex">
						<div class="service-widget service-six flex-fill aos" data-aos="fade-up">
							<div class="service-img">
								<router-link to="/blogs/blog-details">
									<img class="img-fluid serv-img" alt="Service Image"
										src="@/assets/img/blog/celaning-blog-01.jpg">
								</router-link>
							</div>
							<div class="service-content service-content-six">
								<h5 class="blog-import-service">How to effectively evaluate offers from commercial cleaning companies</h5>
								<p>In today’s fast-paced business world, finding the right services to support your growth can be a game...</p>
								<a href="#">Read More</a>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6 col-12 d-flex">
						<div class="service-widget service-six flex-fill aos" data-aos="fade-up">
							<div class="service-img">
								<router-link to="/blogs/blog-details">
									<img class="img-fluid serv-img" alt="Service Image"
										src="@/assets/img/blog/celaning-blog-02.jpg">
								</router-link>
							</div>
							<div class="service-content service-content-six">
								<h5 class="blog-import-service">Commercial Moving Solutions By Three Movers</h5>
								<p>One of the biggest advantages of using a service marketplace is the access to a wide range of services.</p>
								<router-link to="/blogs/blog-details">Read More</router-link>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6 col-12 d-flex">
						<div class="service-widget service-six flex-fill aos" data-aos="fade-up">
							<div class="service-img">
								<router-link to="/blogs/blog-details">
									<img class="img-fluid serv-img" alt="Service Image"
										src="@/assets/img/blog/celaning-blog-03.jpg">
								</router-link>
							</div>
							<div class="service-content service-content-six">
								<h5 class="blog-import-service">Importance Of Professional Cleaning Services</h5>
								<p>Before hiring a service provider, check their reviews and ratings on the marketplace...</p>
								<router-link to="/blogs/blog-details">Read More</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    <!-- /Latest Blog -->
</template>

<script>
export default {
    
}
</script>